/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Component, JSXElement, Show } from 'solid-js';

export interface ProgressBarProps {
  /** Progress value as percentage (0-100) */
  progress?: number;
  /** Progress value as string (e.g., "45%") */
  progressPercent?: string;
  /** Additional CSS classes */
  class?: string;
  /** Whether to show the progress bar */
  show?: boolean;
  /** Content to render inside the progress bar */
  content?: JSXElement;
  /** Whether to wrap in footer element (for progress-widget compatibility) */
  inFooter?: boolean;
}

const ProgressBar: Component<ProgressBarProps> = (props) => {
  const getProgress = () => {
    if (props.progressPercent) {
      return props.progressPercent;
    }
    if (props.progress !== undefined) {
      return `${props.progress.toString()}%`;
    }
    return '0%';
  };

  const getShow = () => props.show ?? true;
  const getClassName = () =>
    props.class ? `progressbar ${props.class}` : 'progressbar';

  const progressBarElement = (
    <div role="progressbar" class={getClassName()}>
      <span style={{ width: getProgress() }} />
      {props.content}
    </div>
  );

  return (
    <Show when={getShow()}>
      {props.inFooter ? (
        <footer>{progressBarElement}</footer>
      ) : (
        progressBarElement
      )}
    </Show>
  );
};

export default ProgressBar;
